import { render, staticRenderFns } from "./vipCustomer.vue?vue&type=template&id=722450fd"
import script from "./vipCustomer.vue?vue&type=script&lang=js"
export * from "./vipCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports